import { loginHistoryType } from "./type";

const initialAuthState = {
  loginHistoryList: null,
  isLoading: false,
  statusCode: null
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case loginHistoryType.GET_LOGIN_HISTORY_LIST_REQUEST:
      return { ...state, isLoading: true };
    case loginHistoryType.GET_LOGIN_HISTORY_LIST_SUCCESS:
      return { ...state, isLoading: false, loginHistoryList: action.payload.data };
    case loginHistoryType.GET_LOGIN_HISTORY_LIST_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
};
